import React from 'react';
import ReactDOM from 'react-dom';

class CopyToClipboard {
  constructor() {
    this._isCopySupported = false;
  }

  _renderTextArea(value, containerElement) {
    let textArea = React.createElement('textarea', {
      id: 'copy-textarea',
      style: {
        position: 'fixed',
        padding: '0px',
        top: '0px',
        left: '0px',
        width: '2em',
        height: '2em',
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        background: 'transparent',
      },
      defaultValue: value
    });

    ReactDOM.render(textArea, containerElement);
  }

  checkCopySupported() {
    try {
      this._isCopySupported = document.queryCommandSupported('copy');
    }
    catch (ex) {
      return false;
    }
    return true;
  }

  get isCopySupported() {
    return this._isCopySupported;
  }

  copyToClipboard(value, containerElement) {
    let createContainerDiv = containerElement === undefined;

    if (createContainerDiv) {
      containerElement = document.createElement('div');
      document.body.appendChild(containerElement);
    }

    let textArea = this._renderTextArea(value, containerElement);
    try {
      document.getElementById('copy-textarea').select();
      document.execCommand('copy');
    }
    catch (ex) {
      return false;
    }
    finally {
      if (createContainerDiv) {
        document.body.removeChild(containerElement);
      } else {
        ReactDOM.unmountComponentAtNode(containerElement);
      }
    }
    return true;
  }
}

const instance = new CopyToClipboard();
export { CopyToClipboard as default, instance };